import { createBrowserRouter, Navigate, useParams } from "react-router-dom";
import { AppLayout } from "./components/layout/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import NewAnalysisPage from "./pages/NewAnalysisPage";
import AnalysisDetailPage from "./pages/AnalysisDetailPage";
import MockupStudioPage from "./pages/MockupStudioPage";
import VideoStudioPage from "./pages/VideoStudioPage";
import DesignBuilderListPage from "./pages/ListingBuilderListPage";
import DesignBuilderPage from "./pages/ListingBuilderPage";
import ListingBuilderPage from "./pages/EtsyListingBuilderPage";
import JewelryListingBuilderPage from "./pages/JewelryListingBuilderPage";
import JewelryDashboardPage from "./pages/JewelryDashboardPage";
import ShopsPage from "./pages/ShopsPage";
import MyShopsPage from "./pages/MyShopsPage";
import JewelryStudioPage from "./pages/JewelryStudioPage";
import JewelryBulkStudioPage from "./pages/JewelryBulkStudioPage";
import ShopDetailPage from "./pages/ShopDetailPage";
import MockupManagerPage from "./pages/MockupManagerPage";
import SettingsPage from "./pages/SettingsPage";
import AiUsagePage from "./pages/AiUsagePage";
import ListingReviewPage from "./pages/ListingReviewPage";
import JewelryReviewPage from "./pages/JewelryReviewPage";
import JewelryProductsPage from "./pages/JewelryProductsPage";
import EtsyCallbackPage from "./pages/EtsyCallbackPage";
import CanvaCallbackPage from "./pages/CanvaCallbackPage";
import CanvaEditorPage from "./pages/CanvaEditorPage";
import EtsyProductsPage from "./pages/EtsyProductsPage";
import EtsyOrdersPage from "./pages/EtsyOrdersPage";
import EtsyReviewsPage from "./pages/EtsyReviewsPage";
import BuyerMessagesPage from "./pages/BuyerMessagesPage";
import StorefrontPage from "./pages/StorefrontPage";
import PinterestPage from "./pages/PinterestPage";
import TrendIntelligencePage from "./pages/TrendIntelligencePage";
import SalesDashboardPage from "./pages/SalesDashboardPage";
import StatsPage from "./pages/StatsPage";
import InventoryManagementPage from "./pages/InventoryManagementPage";
import ListingTemplatesPage from "./pages/ListingTemplatesPage";
import ListingSchedulerPage from "./pages/ListingSchedulerPage";
import PricingAssistantPage from "./pages/PricingAssistantPage";
import BulkOperationsPage from "./pages/BulkOperationsPage";
import SupplierCatalogsPage from "./pages/SupplierCatalogsPage";
import DesignsPage from "./pages/DesignsPage";
import DesignEnginePage from "./pages/DesignEnginePage";
import PlansPage from "./pages/PlansPage";
import ConceptsPage from "./pages/ConceptsPage";
import ProductAnalysesPage from "./pages/ProductAnalysesPage";
import ErankAnalysisPage from "./pages/ErankAnalysisPage";
import DiscoveryPage from "./pages/DiscoveryPage";
import TasksPage from "./pages/TasksPage";
import McpConnectorPage from "./pages/McpConnectorPage";
import PackageEditorPage from "./pages/PackageEditorPage";
import CustomListingsPage from "./pages/CustomListingsPage";
import CustomStudioPage from "./pages/CustomStudioPage";
import OAuthAuthorizePage from "./pages/OAuthAuthorizePage";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    // MCP baglayicisi (ChatGPT / Claude) OAuth onay ekrani — menusuz
    path: "/oauth/authorize",
    element: <OAuthAuthorizePage />,
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: "dashboard",
        element: <DashboardPage />,
      },
      {
        path: "analyses",
        element: <ProductAnalysesPage />,
      },
      {
        path: "erank",
        element: <ErankAnalysisPage />,
      },
      {
        path: "discovery",
        element: <DiscoveryPage />,
      },
      {
        path: "tasks",
        element: <TasksPage />,
      },
      {
        path: "analyses/new",
        element: <NewAnalysisPage />,
      },
      {
        path: "analyses/:id",
        element: <AnalysisDetailPage />,
      },
      {
        // Eski taslak detay sayfasi: artik Listing Builder editoru
        path: "listing-drafts/:id",
        element: <DraftRedirect />,
      },
      {
        path: "listing-drafts",
        element: <DashboardPage />,
      },
      {
        path: "design-builder",
        element: <DesignBuilderListPage />,
      },
      {
        path: "design-builder/:id",
        element: <DesignBuilderPage />,
      },
      {
        path: "listing-builder",
        element: <ListingBuilderPage />,
      },
      {
        // Taki hatti: tedarikci urununden taslak. Pazaryeri aktif magazadan
        // gelir (Etsy veya Trendyol), sayfa ayni.
        path: "listing-builder/jewelry",
        element: <JewelryListingBuilderPage />,
      },
      {
        // Eski yol — kayitli baglantilar calismaya devam etsin
        path: "listing-builder/trendyol",
        element: <JewelryListingBuilderPage />,
      },
      {
        path: "video-studio",
        element: <VideoStudioPage />,
      },
      {
        path: "mockup-studio",
        element: <MockupStudioPage />,
      },
      {
        path: "mockup-manager",
        element: <MockupManagerPage />,
      },
      {
        path: "shops",
        element: <ShopsPage />,
      },
      {
        // Kendi satis magazalarimiz (rakip takibi olan /shops ile karistirma)
        path: "my-shops",
        element: <MyShopsPage />,
      },
      {
        // Taki panosu — Trendyol ve Etsy taki magazalari icin ortak.
        // Eski /trendyol yolu kayitli baglantilar icin duruyor.
        path: "jewelry-dashboard",
        element: <JewelryDashboardPage />,
      },
      {
        path: "trendyol",
        element: <JewelryDashboardPage />,
      },
      {
        // Taki uretimi: konsept fotografi + katalog urunu
        path: "jewelry-studio",
        element: <JewelryStudioPage />,
      },
      {
        // Toplu fotograf uretimi: urun basina ayri ayar, tek tikla kuyruk
        path: "jewelry-studio/bulk",
        element: <JewelryBulkStudioPage />,
      },
      {
        path: "shops/:id",
        element: <ShopDetailPage />,
      },
      {
        path: "trend-intelligence",
        element: <TrendIntelligencePage />,
      },
      {
        path: "concepts",
        element: <ConceptsPage />,
      },
      {
        path: "etsy/products",
        element: <EtsyProductsPage />,
      },
      {
        path: "etsy/orders",
        element: <EtsyOrdersPage />,
      },
      {
        path: "etsy/reviews",
        element: <EtsyReviewsPage />,
      },
      {
        path: "etsy/messages",
        element: <BuyerMessagesPage />,
      },
      {
        path: "storefront",
        element: <StorefrontPage />,
      },
      {
        path: "pinterest",
        element: <PinterestPage />,
      },
      // New pages
      {
        path: "sales-dashboard",
        element: <SalesDashboardPage />,
      },
      {
        // Finans, Istatistikler'in sekmeleri oldu (kar-zarar, reklam, ilan sagligi)
        path: "finance",
        element: <Navigate to="/stats?tab=pnl" replace />,
      },
      {
        path: "stats",
        element: <StatsPage />,
      },
      {
        path: "inventory",
        element: <InventoryManagementPage />,
      },
      {
        path: "templates",
        element: <ListingTemplatesPage />,
      },
      {
        path: "scheduler",
        element: <ListingSchedulerPage />,
      },
      {
        path: "pricing",
        element: <PricingAssistantPage />,
      },
      {
        path: "bulk-operations",
        element: <BulkOperationsPage />,
      },
      {
        path: "supplier-catalogs",
        element: <SupplierCatalogsPage />,
      },
      {
        path: "designs",
        element: <DesignsPage />,
      },
      {
        path: "design-engine",
        element: <DesignEnginePage />,
      },
      {
        path: "plans",
        element: <PlansPage />,
      },
      {
        path: "listing-review",
        element: <ListingReviewPage />,
      },
      {
        // Custom Liste Studyosu: pano + tek urunun 7 adimi
        path: "custom",
        element: <CustomListingsPage />,
      },
      {
        path: "custom/:id",
        element: <CustomStudioPage />,
      },
      {
        // Liste paketi duzenleyici (Etsy ilan sayfasi duzeni)
        path: "packages/:id",
        element: <PackageEditorPage />,
      },
      {
        // Taki: fotografi uretilmis urunlerden toplu taslak
        path: "listing-review/jewelry",
        element: <JewelryReviewPage />,
      },
      {
        // Taki: fotografi uretilmis urunler
        path: "jewelry-products",
        element: <JewelryProductsPage />,
      },
      {
        path: "ai-usage",
        element: <AiUsagePage />,
      },
      {
        path: "chatgpt",
        element: <McpConnectorPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "settings/etsy-callback",
        element: <EtsyCallbackPage />,
      },
      {
        path: "canva/callback",
        element: <CanvaCallbackPage />,
      },
      {
        path: "canva/editor",
        element: <CanvaEditorPage />,
      },
    ],
  },
]);

/** Eski /listing-drafts/:id baglantilari Listing Builder editorune gider */
function DraftRedirect() {
  const { id } = useParams();
  return <Navigate to={`/listing-builder?id=${id ?? ""}`} replace />;
}
